import React from "react";
import "./Footer.css";
import {     SiSemanticuireact} from "react-icons/si";

import { MdMedicalServices } from "react-icons/md";
import {MdContactPhone } from "react-icons/md";      

import {FaUserGraduate } from "react-icons/fa"; 
import { FaHome } from "react-icons/fa";
import {BsGithub } from "react-icons/bs"; 
import {BsLinkedin} from "react-icons/bs"; 
import { BsFacebook } from "react-icons/bs"; 
import { BsInstagram } from "react-icons/bs";
import { BsTwitter } from "react-icons/bs";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer-logo">
      FIND ME ON
Feel free to<span className="connect"> connect </span> with me
      </a>
      <ul className="permalinks">
        <li>
        <FaHome/>
          <a href="#"> Home</a>
        </li>
        <li>
          <FaUserGraduate/>
          <a href="#about"> About</a>
        </li>
      
        <li>
          <MdMedicalServices/>
          <a href="#services"> Resume</a>
        </li>
        <li>
          <SiSemanticuireact/>
          <a href="#portfolio"> Project</a>
        </li>
     
        <li>
          <MdContactPhone/>
          <a href=" #contact "> Contact</a>
        </li>
      </ul>
      <div className="footer-socials">
      <a href=" https://www.linkedin.com/in/niraj-yadav-88024a227/
               ">
      <BsLinkedin/>
        </a>
      <a href="https://github.com/niraj2634">
     < BsGithub/>
        </a>
        <a href="https://facebook.com">
          <BsFacebook />
        </a>

        <a href="https://instagram.com">
          <BsInstagram />
        </a>
        <a href="https://twitter.com">
          <BsTwitter />
        </a>
      </div>

      <div className="footer-copyright">
        <small>Copyright © 2022 .{"  "}   Designed and Developed by Niraj Kumar.</small>
      </div>
    </footer>
  );
};

export default Footer;